import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FeatureOverview from "./sections/FeatureOverview";
import ImageGrid from "./sections/ImageGrid";
import Team from "./sections/Team";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FeatureOverview />
      <ImageGrid />
      <Team />
      <Contact />
      <Footer />
    </div>;
}